import {useState,useEffect} from 'react';
import {useWordsList} from './utils';
import Wordbox from "./Wordbox";
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faTimesCircle,faCheckCircle} from "@fortawesome/free-solid-svg-icons";
import {Redirect} from 'react-router-dom';



const Window = ({correct,setCorrect}) => {

  const { word, generateNew, tabooWords, pending, error } = useWordsList();
  const [timer,setTime] = useState();
 
 


  function handleTimer(){
    let stopWatch = setTime(100);
    
    setInterval(()=>{
      setTime(timer => timer -1);
     
    },1000)
   return () => {
     clearInterval(stopWatch);
   }
  }

  useEffect(handleTimer,[]);

  function correctTracker(){
    generateNew();
    setCorrect(correct => correct+1);
    console.log(correct);
  }

 

  useEffect(()=>{
    setCorrect(0);
    return () =>{
    }
  },[]);

  if(timer <= 0){
    return <Redirect to ="/Timesup" />;
  }

  return (
    <div className="main-window">
      <div className="timer">
        <input type="range"  min= "0" max="60"/>
        <div style = { {transform: `translateX(${timer}%)`}} className="animate-track">

        </div>
      </div>
     <div className="word-box">
     <Wordbox mainword = {word} taboowords = {tabooWords} ispending ={pending}  error ={ error} ></Wordbox>
     </div>
     <div className="panel">
        <div className = "wrong" onClick = {()=>generateNew()}> 
          <FontAwesomeIcon icon = {faTimesCircle} />
        </div>
        <div className = "correct" onClick = {()=>correctTracker()}> 
          <FontAwesomeIcon icon = {faCheckCircle} />
        </div>
     </div>
    </div>
  );
}
 
export default Window;

